import React, { useState } from 'react';
import { Row, Col } from 'reactstrap'

// DATA TABLE
import ControldocDataTable from "../../controldoc/datatable";

const CheckListProcessEntityTable = props => {
  const {
    checkListEntities,
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      context,
      defaultRequestParams,
      entityKey,
      showDistributionListFilter,
    },
    routes: {
      indexEntitiesPath
    },
    callbacks: {
      callbackHandleProcessData
    },
    errors
  } = props;

  const [entitiesSelected, setEntitiesSelected] = useState(_.map(checkListEntities, 'entity') || [])

  const entitiesErrors = () => {
    if(errors){
      return(
        <div className="alert alert-danger">
          <ul className='mb-0'>
            {
              _.map(errors, (error) => {
                return(
                  <li key={ _.uniqueId("entityError-") }>
                    { error }
                  </li>
                )
              })
            }
          </ul>
        </div>
      )
    }
  }

  const onSelectionChange = selectedRecords => {
    if(_.isFunction(callbackHandleProcessData)){
      let _event = { target: { value: _.map(selectedRecords, 'id') } }

      callbackHandleProcessData(_event, 'entity_ids')
    }
    setEntitiesSelected(selectedRecords)
  }

  return(
    <Row>
      <Col md={12}>
        { entitiesErrors() }
        <ControldocDataTable
          columns={ dataTableColumns }
          configuration={{
            showDistributionListFilter: showDistributionListFilter,
            showGridlines: true,
            context: context,
            fetchRecords: {
              endpoint: indexEntitiesPath,
              keyName: entityKey,
              defaultRequestParams: defaultRequestParams
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: entitiesSelected,
              onSelectionChange: onSelectionChange
            }
          }}
        >
        </ControldocDataTable>
      </Col>
    </Row>
  )
}

export default CheckListProcessEntityTable;
